import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Inspection } from '../../shared/interfaces';

@Component({
  selector: 'app-inspection-files',
  templateUrl: './inspection-files.component.html',
  styleUrls: ['./inspection-files.component.scss'],
})
export class InspectionFilesComponent implements OnInit {
  inspection;
  _isUploading = false;
  get isUploading() {
    return this._isUploading;
  }
  set isUploading(value) {
    this._isUploading = value;
    (window as any).isUploading = value;
  }

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.data.subscribe(async (data: { inspection: Inspection }) => {
      if (data.inspection) {
        this.inspection = data.inspection;
      }
    });
  }
}
